import todo from "../assets/work/todo.png";
import keeper from "../assets/work/keeper.png";
import drumkit from "../assets/work/drumkit.png";
import gericht from "../assets/work/gericht.png"

export const data = [
    {
        img : keeper,
        desc : `"The keeper app" keeping all your todos, built with React JS`,
        code : "https://github.com/1mpactBot/The-Keeper",
        demo : "https://ph2km.csb.app/"
    },
    {
        img : todo,
        desc : "React JS application displaying lists of remaining and completed todos",
        code : "https://github.com/1mpactBot/todo-app",
        demo : "https://1r7mh.csb.app/"
    },
    {
        img : drumkit,
        desc : "Drumkit made with vanilla javascript",
        code : "https://github.com/1mpactBot/Drum-kit",
        demo : "/work"
    },
    {
        img : gericht,
        desc : "Restaurant page using ReactJS",
        code : "https://github.com/1mpactBot/gericht-restaurant",
        demo : "https://gericht-restaurant-fawn.vercel.app/"
    },

]